import { useCallback, useEffect, useState } from 'react';
import DriverRecognitionCard from './DriverRecognitionCard';
import './ControlPanel.css';

export default function ControlPanel({ vehiculoSeleccionado, onClose }) {
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [recognition, setRecognition] = useState(null);
  const vehicle = vehiculoSeleccionado;
  const id = vehicle?.maccezVehicleId ??
    ((!vehicle?.source || vehicle.source === 'maccez-database') ? vehicle?.id : null);
  const active = vehicle?.licenseValid !== false;
  const key = `${id || ''}:${vehicle?.imei || ''}:${vehicle?.owner_user_id || ''}`;
  const onProfile = useCallback(profile => setRecognition({ key, profile }), [key]);
  const assigned = recognition?.key === key && recognition.profile?.configured;
const motorReserved = assigned &&
  Number(recognition.profile.protectedOutput) === 1 &&
  recognition.profile.mode !== 'bypassed';
  const hornReserved = assigned && Number(recognition.profile.protectedOutput) === 2;

  useEffect(() => { setMessage(''); }, [key]);

  async function send(output, confirmText) {
    if (!id || !active || busy) return;
    if (confirmText && !window.confirm(confirmText)) return;
    setBusy(true);
    setMessage('Esperando confirmación del GPS…');
    try {
      const response = await fetch(`/api/devices/${id}/commands/output`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ output })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Comando rechazado');
      setMessage(output === 'door_pulse' ? 'Puertas activadas.' :
        output === 'horn_signal' ? 'Claxon activado.' : 'GPS confirmó el comando.');
    } catch (error) {
      setMessage(error.message);
    } finally {
      setBusy(false);
    }
  }

  return <main className="control-page">
    <div className="control-content">
      <header className="control-heading">
        <button className="control-back" type="button" onClick={onClose} aria-label="Volver">‹</button>
        <div><span>CONTROL DEL VEHÍCULO</span><h1>{vehicle?.name || 'Selecciona un activo'}</h1></div>
      </header>
      {!id || !vehicle?.imei ? <div className="control-empty">
        <span aria-hidden="true">◇</span>
        <h2>Selecciona un activo</h2>
        <p>Elige un vehículo para consultar sus controles y su sensor.</p>
      </div> : <>
        {!active && <p className="control-alert">La licencia de este activo no está vigente.</p>}
        <DriverRecognitionCard key={key} vehicle={vehicle} busyControl={busy} onProfile={onProfile} />
        <div className="control-grid">
          <section className="control-tile">
            <div className="control-tile-heading"><span aria-hidden="true">⏻</span><h2>Motor</h2></div>
            {motorReserved ? <p className="control-motor-info">Deshabilita el reconocimiento de conductor para usar el bloqueo manual del motor.</p> :
            <div className="control-actions-two">
              <button type="button" disabled={!active || busy} onClick={() => send('out1_on', '¿Bloquear el arranque?')}>Bloquear motor</button>
              <button type="button" disabled={!active || busy} onClick={() => send('out1_off', '¿Liberar el arranque?')}>Liberar motor</button>
            </div>}
          </section>
          <section className="control-tile">
            <div className="control-tile-heading"><span aria-hidden="true">▣</span><h2>Puertas</h2></div>
            <button className="control-primary" type="button" disabled={!active || busy}
              onClick={() => send('door_pulse', '¿Abrir las puertas?')}>Abrir puertas <span aria-hidden="true">›</span></button>
          </section>
          {!hornReserved && <section className="control-tile">
            <div className="control-tile-heading"><span aria-hidden="true">◉</span><h2>Claxon</h2></div>
            <button className="control-primary" type="button" disabled={!active || busy}
           onClick={() => send('horn_signal', '¿Activar el claxon?')}>Activar claxon <span aria-hidden="true">›</span></button>
          </section>}
        </div>
      </>}
      {message && <p className="control-feedback" role="status" aria-live="polite">{message}</p>}
    </div>
  </main>;
}
